"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ActionTypeEnum;
(function (ActionTypeEnum) {
    ActionTypeEnum["EQUALIZE"] = "equalize";
    ActionTypeEnum["BLACKLIST"] = "blacklist";
    ActionTypeEnum["BOOST"] = "boost";
    ActionTypeEnum["PRODUCTS_RANKING"] = "productsRanking";
    ActionTypeEnum["ATTRIBUTES_RANKING"] = "attributesRanking";
    ActionTypeEnum["LINK"] = "link";
    ActionTypeEnum["PROMOTION"] = "promotion";
    ActionTypeEnum["REDIRECTION"] = "redirection";
    ActionTypeEnum["SYNONYM"] = "synonym";
    ActionTypeEnum["CONFIGURATION"] = "configuration";
    ActionTypeEnum["INSTANCE"] = "instance";
})(ActionTypeEnum = exports.ActionTypeEnum || (exports.ActionTypeEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWN0aW9uLXR5cGUuZW51bS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbnVtcy9hY3Rpb24tdHlwZS5lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsSUFBWSxjQVlYO0FBWkQsV0FBWSxjQUFjO0lBQ3hCLHVDQUFxQixDQUFBO0lBQ3JCLHlDQUF1QixDQUFBO0lBQ3ZCLGlDQUFlLENBQUE7SUFDZixzREFBb0MsQ0FBQTtJQUNwQywwREFBd0MsQ0FBQTtJQUN4QywrQkFBYSxDQUFBO0lBQ2IseUNBQXVCLENBQUE7SUFDdkIsNkNBQTJCLENBQUE7SUFDM0IscUNBQW1CLENBQUE7SUFDbkIsaURBQStCLENBQUE7SUFDL0IsdUNBQXFCLENBQUE7QUFDdkIsQ0FBQyxFQVpXLGNBQWMsR0FBZCxzQkFBYyxLQUFkLHNCQUFjLFFBWXpCIn0=